const gapps = {
	providerCode: "gapps",
	providerName: "Google",
	providerFullName: "Google Workspace for Education",
	directoryName: "Google Directory",
	classroomName: "Google Classroom",
	features: {
		ou: true,
		ou_structure: true,
		group: true,
		classroom: true,
		account_crud: true,
		sync: true
	}
};

const gappsm = {
	providerCode: "gappsm",
	providerName: "Google Match",
	providerFullName: "Google Workspace for Education",
	directoryName: "Google Directory",
	classroomName: "Google Classroom",
	features: {
		ou: true,
		ou_structure: false,
		group: false,
		classroom: false,
		account_crud: false,
		sync: false
	}
};

const msft = {
	providerCode: "msft",
	providerName: "Microsoft",
	providerFullName: "Microsoft Azure Active Directory",
	directoryName: "Active Directory",
	classroomName: "Microsoft Azure Active Directory",
	features: {
		ou: true,
		ou_structure: false,
		group: true,
		classroom: false,
		account_crud: true,
		sync: true
	}
};

const msad = {
	providerCode: "msad",
	providerName: "Microsoft",
	providerFullName: "Microsoft Active Directory",
	directoryName: "Active Directory",
	classroomName: null,
	features: {
		ou: true,
		ou_structure: false,
		group: false,
		classroom: false,
		account_crud: true,
		sync: true
	}
};

const apl = {
	providerCode: "apl",
	providerName: "Apple",
	providerFullName: "Apple School Manager",
	directoryName: "ASM",
	classroomName: null,
	features: {
		ou: false,
		ou_structure: false,
		group: false,
		classroom: false,
		account_crud: false,
		sync: true
	}
};

export default {
	get() {
		switch (window.location.hostname) {
			case process.env.VUE_APP_GAPPS_APP_DOMAIN:
				return gapps;
			case process.env.VUE_APP_MSFT_APP_DOMAIN:
				return msft;
			case process.env.VUE_APP_MSAD_APP_DOMAIN:
				return msad;
			case process.env.VUE_APP_GAPPSM_APP_DOMAIN:
				return gappsm;
			case process.env.VUE_APP_APL_APP_DOMAIN:
				return apl;
		}
	}
};
